var map = {
	"./bigpromotion-logo.png": 27591,
	"./deposit-logo.png": 79092,
	"./fullpay-logo.png": 97031,
	"./group-logo.png": 29593,
	"./quickbuy-logo.png": 88773,
	"./vip-logo.png": 94549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33125;